import { GTMEvent } from '../GTM'

export type GTMProductData = {
    name: string
}

export const EVENT = 'get_user_data'

let lastPushedLoginStatus: string | undefined

export const pushUserCustomData = (
    data: Record<string, unknown>,
    eventHistory: () => string[]
): GTMEvent | undefined => {
    const loginStatus = (data?.ecommerce as Record<string, unknown> | undefined)
        ?.login_status as string | undefined

    if (
        eventHistory().includes(EVENT) &&
        loginStatus === lastPushedLoginStatus
    ) {
        return
    }

    lastPushedLoginStatus = loginStatus

    return {
        event: EVENT,
        ...data,
        _clear: true
    }
}
